import {DateTime} from 'luxon';

/**
 * Centralized identifiers shared between the event-calendar component,
 * the sticky-occurrences directive, and the SCSS selectors that key on them.
 * Drift between these locations causes silent UI breakage.
 */
export const OCCURRENCES_RESOURCE_ID = 'occurrences';
export const OCCURRENCE_CATEGORY_PREFIX = 'occurrence-category-';
export const BERLIN_TZ = 'Europe/Berlin';

/** Position offset for the legacy `reserved_*` event-resource state titles. */
export const RESERVED_OPTION_ORDER: Readonly<Record<string, number>> = {
  reserved_second_option: 2,
  reserved_third_option: 3,
  reserved_fourth_option: 4,
  reserved_fifth_option: 5,
};

const ISO_OPTS = {format: 'extended', suppressMilliseconds: true} as const;

/** Coerces an ISO string or DateTime to a Berlin-zoned ISO string. */
export function toBerlinIso(input: string | DateTime | undefined | null): string | undefined {
  if (input == null) return undefined;
  const dt = typeof input === 'string' ? DateTime.fromISO(input) : input;
  return dt.setZone(BERLIN_TZ).toISO(ISO_OPTS) ?? undefined;
}
